import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import Icon from '../Icon';

const DialogToolbar = ({ title, onClose }) => (
  <AppBar position="sticky" color="transparent">
    <Toolbar>
      {onClose && (
        <IconButton
          edge="start"
          color="inherit"
          onClick={onClose}
          aria-label="close"
          style={{ marginRight: 2 }}
        >
          <Icon icon={['fal', 'times']} />
        </IconButton>
      )}
      <Typography variant="h6" noWrap>
        {title}
      </Typography>
    </Toolbar>
  </AppBar>
);

DialogToolbar.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func,
};

DialogToolbar.defaultProps = {
  onClose: undefined,
};

export default DialogToolbar;
